import { dsHttp, DIGITAL_SIZER_BASE_URL } from "../lib/digitalSizerHttp";

// Shared client for LOS-backed features. Auth (Bearer JWT + X-Role) is injected
// by the interceptors — see src/lib/digitalSizerHttp.js. Kept as hooks for
// call-site compatibility.
//
// - useDigitalSizerClient → dsHttp → eastview-los (the LOS) backend.
//
// The standalone digital-sizer-web client was removed: every feature now targets
// eastview-los. Endpoints the LOS doesn't serve yet are flagged "TBD" at the
// call site and will 404 until the backend adds them.
export { DIGITAL_SIZER_BASE_URL };

export const useDigitalSizerClient = () => dsHttp;

export default useDigitalSizerClient;
